/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const REQ_ACC_REC_ROUTE = '/reqAccReceivable';
export const AR_SUMRY_BY_MFG_ROUTE = '/arSummaryByMfg';
export const AR_SUMRY_BY_QTR_ROUTE = '/ARSummaryByQtr';
export const AR_SUMRY_BY_QTR_ACCOUNT_SINGLE_ROUTE = '/QtrAccountsRec';
export const AR_SUMRY_BY_QTR_ACCOUNT_ALL_ROUTE = '/QtrAccountsRecAll';
export const AR_SUMRY_MFG_ALL = '/arSummaryByMfgAll';
export const MANU_AR_ROUTE = '/mfgAccountRec';
export const AR_SUMRY_BY_QTR_ALL_ROUTE = '/ARSummaryByQtrAll';
export const AR_MANUFACTURER_ROUTE = '/ARManufacturer';
export const AR_SUMRY_BY_ACCOUNT_NDC_ALL_ROUTE = '/AccRecNDCDetailAll';
export const AR_SUMRY_BY_ACCOUNT_NDC_SINGLE_ROUTE = '/AccRecNDCDetail';
export const AR_ACCOUNT_NDC_ACTIVITY_ROUTE = '/AccRecNDCActivity';
export const MFG_BANKRUPT_ERR = "'Declare Manufacturer Bankrupted' failed.";
export const NOTHING_TO_PROCESS = 'Nothing to process';
export const BANKRUPT_CONFIRM_MSG =
  'Manufacturer has not been declared bankrupt. Would you like to declare this manufacturer bankrupted?';
export const DRAMS_QTR_ERR =
  'Drams Invoice Start Quarter is missing for this rebate program code.';
export const FIRST_SMRY_QTR_ERR =
  'First Summary Report Quarter is missing for this rebate program code.';
export const MFG_REQ_ERR = 'Please select a manufacturer or All Manufacturers.';
export const REBATE_PGM_REQ = 'Rebate Program is required.';
// Declare invoice balanced
export const invoiceDeclaredBalancedMsg =
  'Invoice has already been declared balanced!';
export const invoiceNotFrozenMsg =
  'Can not declare invoice as balanced because invoice has not been frozen!';
export const invoiceIsForgivenMsg =
  'Can not declare invoice as balanced because invoice is forgiven!';
export const invoiceWrittenOffMsg =
  'Can not declare invoice as balanced because invoice is written off!';
export const invoiceBalanceCompleted = "'Declare Invoice Balanced' completed!";
export const invoiceBalanceFailed = "'Declare Invoice Balanced' failed!";
export const invoiceFrozen =
  'Can not declare invoice as balanced because invoice has not been frozen!';

// Undo declare invoice balanced
export const undoForgivenMsg =
  'Can not undo declare invoice as balanced because invoice is forgiven!';
export const undoWrittenOff =
  'Can not undo declare invoice as balanced because invoice is written off!';
export const undoDeclareBalanced =
  'Invoice has not been declared balanced. Would you like to declare Invoice balanced?';
export const undoDeclareBalancedCompleted =
  "'Undo Declare Invoice Balanced' completed!";
export const undoDeclareBalancedFailed =
  "'Undo Declare Invoice Balanced' failed!";

// Error Mesages
export const FROM_QTR_ERR = 'From Quarter Is Required.';
export const TO_QTR_ERR = 'To Quarter cannot be less than From Quarter.';

// Declare Invoice Bankrupt
export const invoiceAlreadyBankrupt =
  'Invoice has already been declared bankrupt!';
export const invoiceBankruptFrozon =
  'Can not declare invoice as bankrupted because invoice has not been frozen!';
export const invoiceBankruptForgiven =
  'Can not declare invoice as bankrupted because invoice is forgiven! ';
export const invoiceBankruptWrittenOff =
  'Can not declare invoice as bankrupted because invoice is written off!';
export const invoiceBankruptBalanced =
  'Can not declare invoice as bankrupted because invoice is declare balanced!';
export const invoiceBankruptCompleted = "'Declare Invoice Bankrupt' completed!";
export const invoiceBankruptFailed = "'Declare Invoice Bankrupt' failed!";

// Undo Declare Invoice Bankrupt
export const undoInvoiceBankruptForgiven =
  'Can not undo declare invoice as bankrupted because invoice is forgiven!';
export const undoInvoiceBankruptWrittenOff =
  'Can not undo declare invoice as bankrupted because invoice is written off!';
export const undoInvoiceBankruptBalanced =
  'Can not undo declare invoice as bankrupted because invoice is declare balanced!';
export const undoInvoiceBankruptConfirmMsg =
  'Invoice has not been declared bankrupt. Would you like to declare Invoice bankrupted?';
export const undoInvoiceBankruptCompleted =
  "'Undo Declare Invoice Bankrupted' completed!";
export const undoInvoiceBankruptFailed =
  "'Undo Declare Invoice Bankrupted' failed!";

// Declare NDC balanced
export const NDCBalancedFrozen =
  'Can not declare NDC as balanced because invoice has not been frozen!';
export const NDCAlreadyBalanced = 'Invoice has already been declared balanced!';
export const NDCBalancedCompleted = "'Declare an NDC Balanced' completed.";
export const NDCBalacedFailed = "'Declare an NDC Balanced' failed.";

// Undo Declare NDC balanced
export const undoNDCBalancedConfirmMsg =
  "The Invoice has been declared balanced. Would you like to perform 'Undo' for the entire invoice?";
export const undoNDCDrugMsg =
  "The Drug is not declared balanced, so 'Undo' can not be performed on this drug.";
export const undoNDCCompleted = "'Undo Declare NDC Balanced' completed.";
export const undoNDCFailed = "'Undo Declare NDC Balanced' failed!";

export const modifyUnitsFrozenMsg =
  'Can not modify units because invoice has not been frozen!';

export const modifyUnitsProductCDMsg =
  "Units can not be modified for the drug with the Product Code 'ADJS'.";

export const modifyUnitsErr =
  'You must enter number of units different from current units.';

export const modifyunitFailed =
  'Units have not been modified. No changes will take place.';

// Override Interest
export const overrideInterestFrozenErr =
  'Can not override interest because invoice has not been frozen!';
export const overrideInterestProdCodeErr =
  "The interest can not be overidden for the drug with the Product Code 'ADJS'.";

export const overrideInterestDiffErr =
  'You must enter interest due different from current interest due.';

export const overrideInterestReqErr =
  'You must enter interest due to override.';

export const overrideInterestFailed =
  'Interest Due has not been overridden. No changes will take place.';

// Set units to claims
export const setUnitsFrozenErr =
  'Can not modify units because invoice has not been frozen!';
export const setUnitsProductCDMsg =
  "Units can not be modified for the drug with the Product Code 'ADJS'.";
export const setUnitsNoClaimsFound =
  'No Claims were found. Would you like to Set Units to Zero?';

export const commonSearchPageOther = {
  rebate_list: [],
  rbt_list: [],
  rebate_pgm: '',
  qtr_opt: 'All',
  end_qtr: '',
  start_qtr: '',
  ar_smry_qtr: null,
};
export const commonSearchPage = {
  all_rebate: false,
  err_list: [],
  flderror: {},
  plan_type: 'FD',
  ura_to_use: 'Official',
  display_by: 'Manufacturer',
  all_manu: true,
  firstload: true,
};
export const mfgARHideColumnsInPdf = [
  'offsetDue',
  'baseStateAmountDue',
  'currRoa',
  'baseStateRebateAmount',
  'offsetPaidAmt',
  'baseStateAmountPaid',
  'adjustmentAmount',
  'unitChangeAmt',
  'fedAmt',
  'stateAmount',
  'ccLetterSent',
  'cc_COMMENTS_EXIST',
];
